import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { InternalServerError, NotFound } from "@effect/platform/HttpApiError";
import { ProjectId } from "@open-revenue/schema/identifiers";
import { Schema } from "effect";
import { Authn } from "../authn";
export default HttpApiGroup.make("projectsv1").annotate(OpenApi.Title, "Projects V1").add(HttpApiEndpoint.post("manageWebhooks")`/:projectId/webhooks/manage`.setPath(Schema.Struct({
    projectId: ProjectId.FromString
})).addSuccess(Schema.Struct({
    managementPortalUrl: Schema.String,
    projectId: ProjectId.Schema
})).addError(NotFound).addError(InternalServerError).annotate(OpenApi.Summary, "Create Webhook Management Portal URL").annotate(OpenApi.Description, "Creates and returns a management portal URL for configuring webhooks for the given project")).prefix("/v1/projects").middleware(Authn);
